import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    // Chunk load failures (stale cached bundle after a deploy) — reload once to fetch fresh chunks.
    const msg = String(error?.message || error || "");
    if (/loading chunk|dynamically imported module|failed to fetch dynamically/i.test(msg)) {
      if (!sessionStorage.getItem("lmc_chunk_reload")) {
        sessionStorage.setItem("lmc_chunk_reload", "1");
        window.location.reload();
      }
    }
    // eslint-disable-next-line no-console
    console.error("App error:", error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-navy grain p-6 text-center">
          <div className="max-w-md">
            <p className="font-display text-3xl font-bold text-white">Something went wrong.</p>
            <p className="mt-3 text-white/60">We hit an unexpected error. Please try again.</p>
            <button onClick={() => { this.setState({ hasError: false }); window.location.href = "/"; }}
              className="mt-6 gold-btn rounded-full px-6 py-3 font-semibold" data-testid="error-retry-btn">
              Reload LockMyCollege
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
